<div class="usecase-home">
  <app-sub-header
    [badgeText]="'Healthcare Applications'"
    [title]="'Usecases'"
    [description]="subHeaderDescription"
    [iconSrc]="'/icons/sparkle.svg'"
  ></app-sub-header>

  <section class="usecase-home__grid w-full min-w-0 max-w-full box-border" aria-label="Healthcare use cases">
    @for (card of usecases; track card.id) {
      <app-usecase-card [card]="card" />
    }
  </section>
</div>
<app-footer></app-footer>